import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ActionSheetController, AlertController } from 'ionic-angular';
import { DataProvider } from '../../providers/data/data';
import { Equipos, Personal, Tipochecklist, ViajesResult } from '../../models/maestros';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ControlEquiposDetallePage, ControlEquiposDetalleParams } from '../control-equipos-detalle/control-equipos-detalle';
import { a } from '@angular/core/src/render3';
//import { formArrayNameProvider } from '@angular/forms/src/directives/reactive_directives/form_group_name';

/**
 * Generated class for the ControlEquiposPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-control-equipos',
  templateUrl: 'control-equipos.html',
})
export class ControlEquiposPage {

  public controlData: any = new Object();
  public bindData: { allEquipos: Equipos[], equipos: Equipos[], acoplados: Equipos[], personal: Personal[], checklists: Tipochecklist[] } =
    { allEquipos: null, equipos: null, acoplados: null, personal: null, checklists: null };

  public controlEquiposForm: FormGroup;
  public imagen: string;
  public showBtnSiguiente = false;
  public mShowKms = 0;
  public showLabel: boolean = true;

  constructor(public navCtrl: NavController, public navParams: NavParams, private data: DataProvider,
    private camera: Camera, public actionSheetCtrl: ActionSheetController, formBuilder: FormBuilder, public alertCtrl: AlertController) {

    this.controlEquiposForm = formBuilder.group({
      fecha: ['', Validators.required],
      equipo: [''],
      acoplado: [''],
      personal: [''],
      chofer: [''],
      checklist: ['', Validators.required],
      imagen: [''],
      kilometraje: [0]
    });


    this.data.getEquipos().subscribe(e => {
      if(this.data.todosSectores){
        console.log("Todos los Sectores");
       
        this.bindData.allEquipos = e;
        this.bindData.equipos = e.filter(eq => eq.idcategoriaequipo == 1);
        this.bindData.acoplados = e.filter(eq => eq.idcategoriaequipo == 2);

      } else {
        console.log("Filtro Sectores: ",this.data.filtroSectores);
        //this.bindData.equipos = e.filter(eq => eq.idcategoriaequipo == 1);
        let aux: Array<any> = this.data.filtroSectores;
        console.log('aux',aux);

        this.bindData.allEquipos = e;
        this.bindData.equipos = e.filter(eq => eq.idcategoriaequipo == 1 &&  this.sectorOk(aux,eq.idsector));
        this.bindData.acoplados = e.filter(eq => eq.idcategoriaequipo == 2 && this.sectorOk(aux,eq.idsector));

      }
      console.log("Equipos Filtrados",this.bindData.equipos);
    });


    this.controlEquiposForm.controls.fecha.setValue(new Date().toISOString());

    let id = this.data.user_plantilla;

    console.log("this.data.user_plantilla", this.data.user_plantilla);

    if( id == null ){
      console.log("this.data.user_plantilla es null: ", this.data.user_plantilla);

      id = (this.data.user_despacho == 1) ? 2 : 6;
    }

    this.controlEquiposForm.controls.checklist.setValue( id );
    if( id == 2 ){ this.mShowKms = 1 }

    /*this.data.getEquipos().subscribe(e => {
      this.bindData.allEquipos = e;
      this.bindData.equipos = e.filter(eq => eq.idcategoriaequipo == 1);
      this.bindData.acoplados = e.filter(eq => eq.idcategoriaequipo == 2);
    });*/

    //this.data.getPersonal().subscribe(p => this.bindData.personal = p);

    this.data.getPersonal().subscribe(p => {
      if(this.data.todosSectores){
        this.bindData.personal = p;
      }else{
        
        let aux: Array<any> = this.data.filtroSectores;
        this.bindData.personal = p.filter(pe=> this.sectorOk(aux,pe.idsector));

      }
    });



    this.data.getChecklist().subscribe(p => {
      
      let pp = [];
      for( let i = 0; i < p.length; i++ ){

        if( p[i].actualizadespacho == 1 ){

          if( this.data.user_despacho == 1 ) {
            pp.push( p[i] );
          }
          
        } else {
          pp.push( p[i] );
        }
/*
        if( this.data.user_despacho == 1 && p[i].actualizadespacho == 1 ){
          console.log("despacho == ", p);
          pp.push( p[i] );
          continue;
        } else {
          console.log( i, "no deberia ver esto: despacho == ", p);
          pp.push( p[i] );
        }        */
      }

      this.bindData.checklists = pp;
      console.log( "this.bindData.checklists: ", this.bindData.checklists );
      
    });

  }

  public selectedEquipo: Equipos;
  public selectedAcoplado: Equipos;
  public selectedPersonal: Personal;

  /* --- */

  public equipoChanged(EquipoSel: string) {
    console.log("Codigo Equipo", EquipoSel);

    let aux: Array<any> = this.data.filtroSectores;

    let EqAux: Equipos[] = this.bindData.equipos.filter(a => a.codigo == EquipoSel && a.idcategoriaequipo == 1 && this.sectorOk(aux,a.idsector));
    console.log("Equipo", EqAux);
    
    //valido que no puedan ingresar datos vacios
    //console.log("JH:: EquipoSel.length: ", EquipoSel.length);
    if( EquipoSel.length > 1 )
      this.showBtnSiguiente = true;

    if (EqAux.length > 0) {
  
      this.selectedEquipo = EqAux[0];
      
      console.log('equipo tractor seleccionado:  ',this.selectedEquipo);
      if(this.selectedEquipo){
        this.bindData.acoplados = this.bindData.allEquipos.filter(a => a.codigo == this.selectedEquipo.codigo && a.idcategoriaequipo == 2 &&  this.sectorOk(aux,a.idsector));
        this.controlEquiposForm.controls.kilometraje.setValue(this.selectedEquipo.kilometraje);
        this.showLabel = true;
        console.log('acoplados',this.bindData.acoplados);
      }

      console.log('acoplados',this.bindData.acoplados);
      if (this.bindData.acoplados.length > 0) {
        this.selectedAcoplado = this.bindData.acoplados[0];
        this.controlEquiposForm.controls.acoplado.setValue(this.selectedAcoplado.codigo);
        //this.controlEquiposForm.controls.kilometraje.setValue(this.selectedEquipo.kilometraje);
      } else {
        this.selectedAcoplado = null;
        this.controlEquiposForm.controls.acoplado.setValue('');
  
      }
      //busco personal
      let choferes = this.bindData.personal.filter(p => p.idtractor == this.selectedEquipo.id && this.sectorOk(aux,p.idsector));
      if (choferes.length > 0) {
        this.selectedPersonal = choferes[0];
        this.controlEquiposForm.controls.personal.setValue(this.selectedPersonal.id);
        this.controlEquiposForm.controls.chofer.setValue(this.selectedPersonal.nombre);
      } else {
        this.selectedPersonal = null;
        this.controlEquiposForm.controls.personal.setValue(null);
        this.controlEquiposForm.controls.chofer.setValue('');
      }
    } else {
      this.showBtnSiguiente = false;

      this.selectedEquipo = null;
      this.selectedAcoplado = null;
      this.controlEquiposForm.controls.acoplado.setValue('');
      this.controlEquiposForm.controls.personal.setValue('');
      this.controlEquiposForm.controls.chofer.setValue('');
      this.controlEquiposForm.controls.kilometraje.setValue(0)

    }

  }

  public acopladoChanged(newAcopladoId) {

    //valido que no puedan ingresar datos vacios
    //console.log("JH:: newAcopladoId.length: ", newAcopladoId.length);
    
    let acoplado = this.bindData.acoplados.find(e => e.codigo == newAcopladoId);
    this.selectedAcoplado = acoplado;

    this.showBtnSiguiente = ( acoplado == undefined) ? false : true;    
    
    if( newAcopladoId.length > 1 )
      this.showBtnSiguiente = true;
    else
      this.showBtnSiguiente = false;

  }

  public personalChanged(newPersonalId) {
    if (newPersonalId) {
      this.controlEquiposForm.controls.chofer.setValue(newPersonalId.nombre);
    }
  }

  public plantillaChanged(plantillaId) {

    console.log( "plantillaChanged: checklist: ", this.bindData.checklists );
    console.log( "plantillaChanged: id: ", plantillaId );

    //let chk = this.bindData.checklists.find(e => e.id == plantillaId);
    this.data.user_plantilla = plantillaId;
    this.mShowKms = this.bindData.checklists.find(e => e.id == plantillaId).actualizadespacho;

    console.log( "plantillaChanged: mShowKms: ", this.mShowKms );
  }

  public uploadImage() {
    let buttons = [
      {
        text: 'Sacar foto',
        handler: () => { this.takePhoto(true) },
        role: null
      }, {
        text: 'Elegir desde la galeria',
        handler: () => { this.takePhoto(false) },
        role: null
      }
    ]

    if (this.controlData.imagen) {
      buttons.push({
        text: 'Eliminar foto actual',
        handler: () => { this.imagen = null },
        role: null
      });
    }

    buttons.push({
      text: 'Cancelar', handler: () => { }, role: 'cancel'
    });

    const actionSheet = this.actionSheetCtrl.create({
      title: 'Agregar fotos',
      buttons: buttons
    });
    actionSheet.present();

  }

  takePhoto(camera: boolean) {
    // Camera Options
    const options: CameraOptions = {
      quality: 85,
      destinationType: this.camera.DestinationType.DATA_URL,
      sourceType: camera ? this.camera.PictureSourceType.CAMERA : this.camera.PictureSourceType.PHOTOLIBRARY,
      allowEdit: true,
      encodingType: this.camera.EncodingType.JPEG,
      /*
      targetWidth: 500,
      targetHeight: 500 */
    }
    this.camera.getPicture(options).then((base64String: string) => {
      this.imagen = "data:image/*;base64," + base64String;
    }, (err) => {
      console.log(err);
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ControlEquiposPage');
    console.log('Fecha ', this.controlEquiposForm.controls.fecha.value);
  }


  public sectorOk(sectoresPermitidos: Array<any>, idsector){

    var rta = sectoresPermitidos.filter(function(number) {
      return number == idsector;
    })

    console.log('sectorespermitidos',sectoresPermitidos);

    if(sectoresPermitidos.length==1){
      
      if(sectoresPermitidos[0]==0){
        return true;
      }else{
        if(rta.length>0){
          return true;
        }else{
          return false;
        }  
      }

    }else{
      
      if(rta.length>0){
        return true;
      }else{
        return false;
      }
        
    }

    
  }


  public grabarDatos() {

    console.log("Control data", this.controlEquiposForm.value);
    console.log("Imagen", this.controlData.imageData);


    if (!this.controlEquiposForm.valid) {
      const alert = this.alertCtrl.create({
        title: 'Error',
        subTitle: 'Faltan Completar Datos Obligatorios',
        buttons: ['OK']
      });
      alert.present();
      return;
    }

    
    let args: ControlEquiposDetalleParams = {
      result: this.controlEquiposForm.value,
      acoplado: this.selectedAcoplado,
      equipo: this.selectedEquipo,
      imageData: this.controlData.imageData
    };

    if(this.controlEquiposForm.value.checklist==2){

      this.data.getParams().subscribe(e => {
        var kmsbloqueo = 0;
        var kmsalerta = 0;

        for(let i=0;i<e.length;i++){
          if(e[i].nombre=='KmsBloqueoDespacho'){
            kmsbloqueo = e[i].valor;
          }
          if(e[i].nombre=='KmsAlertaDespacho'){
            kmsalerta = e[i].valor;
          }
        }
      // Validar que el kilometraje ingresado sea mayor que el valor actual
      const kilometrajeIngresado = this.controlEquiposForm.value.kilometraje;
      if (kilometrajeIngresado <= this.selectedAcoplado.kilometraje) {
        const alert = this.alertCtrl.create({
          title: 'Error',
          subTitle: 'El kilometraje ingresado no es mayor que el kilometraje actual del equipo.',
          buttons: ['OK']
        });
        alert.present();
        return; 
      }
        console.log('kmsbloqueo',kmsbloqueo);
        console.log('kmsalerta',kmsalerta);
        console.log('kilometraje ctrl',this.controlEquiposForm.value.kilometraje );
        console.log('kilometraje equipo ',this.selectedEquipo.kilometraje);
        
        if(this.controlEquiposForm.value.kilometraje-this.selectedEquipo.kilometraje > kmsbloqueo){
          const alert = this.alertCtrl.create({
            title: 'Error',
            subTitle: 'El kilometraje ingresado supera los ' +kmsbloqueo+ ' kms. respecto a la última medición realizada del equipo',
            buttons: ['OK']
          });
          alert.present();
          return;
        }else{


          let viajes: any;

          this.data.getAllviajes().subscribe(e => {
            viajes = e.filter(v => v.idtractor == this.selectedEquipo.id && !v.kmfinal);
            console.log('viajes todos para el equ',viajes);

            if(viajes.length==0){
              const alert = this.alertCtrl.create({
                title: 'Error',
                subTitle: 'El equipo no tiene viajes pendientes.',
                buttons: ['OK']
              });
              alert.present();
              return;
            }else{
              this.navCtrl.push(ControlEquiposDetallePage, args);
            }  

          });  

        }
        
      });

    }else{      

      this.navCtrl.push(ControlEquiposDetallePage, args);
    }

  }

  imageFilePath_change(evt) {
    console.log("event de change", evt, evt.target);
    this.attachFile(evt)
      .then(data => this.controlData.imageData = data)
      .catch(error => console.log("Error when trying to save the image", error));
  }

  attachFile(fileInput: any) {
    return new Promise((resolve, reject) => {
      let destination: any = {};

      let file: File = fileInput.target.files[0];

      if (!file) return;

      if (!destination) destination = {};

      destination.filename = file.name;
      destination.size = file.size;

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function () {

        destination.data = reader.result;

        //removes the HTML prefix
        let searchText = "base64,";
        var idx = destination.data.indexOf(searchText);
        if (idx > -1)
          destination.data = destination.data.substring(idx + searchText.length);

        resolve(destination);
      };

      reader.onerror = function (error) {
        reject(error);
      };
    });
  }


}



// WEBPACK FOOTER //
// ./src/pages/control-equipos/control-equipos.ts